import React from "react";
import styles from "./HeroSection.module.scss";
import Button from "components/UI/Button/Button";
import HeroBanner from "../../../../images/hero_section.png";

const HeroSection = () => {
  return (
    <section className={styles.heroSection}>
      <div>
        <h2>Welcome to a community</h2>
        <h2>of creative professionals</h2>
        <p>Create, connect, collaborate with like-minded creatives</p>
        <div className={styles.btns}>
          <Button className={styles.btn} variant="outlined">
            <a href="signin">Log In</a>
          </Button>
          <Button className={styles.btn} variant="filled">
            <a href="signup">Sign Up</a>
          </Button>
        </div>
      </div>
      <div>
        <img src={HeroBanner} alt="Hero-Banner" />
      </div>
    </section>
  );
};

export default HeroSection;
